// Essay templates data based on the provided images
export const essayTemplates = [
  // Image 1: Letters/emails to inform
  {
    id: 'inform-sports-day',
    type: 'inform',
    title: 'Sports Day Information',
    category: 'Letters/emails to inform',
    content: {
      recipient: 'parents',
      sender: 'A Tam, Head of PE Department',
      date: '1 September 20__',
      subject: 'Sports Day',
      greeting: 'Dear parents',
      opening: 'As you are all aware, Sports Day will take place next Friday, 5 September. I would like to inform you of arrangements for that day.',
      mainBody: "Students need to wear their PE uniform to school on 5 September. There are no changing facilities at the sports ground and there will be insufficient time to change after morning registration.\n\nStudents will be taken by school bus to the sports ground in Wan Chai, and Sports Day will begin at 9.00 am sharp. The school principal will give an opening speech and our guest of honour will then address the students.\n\nCompetitive events will run from 9.30 am to midday. At midday, there will be a one hour break for lunch. Students should bring a packed lunch as there are no canteen facilities or places to buy food at the sports ground. Students do not need to bring water as the school will bring bottles of water for everyone. These will be free of charge.\n\nEvents will re-commence at 1.00 pm and prize-giving will take place at 2.30 pm. Dismissal will be earlier than usual and will be at 3.00 pm. Students will not be brought back to school for dismissal. This will take place at the sports ground.",
      conclusion: "I hope you can join us on Sports Day and support the students in their events. If you have any questions about Sports Day, please feel free to email me at sportsteacher@hkschool.com.",
      closing: "Yours sincerely\nA Tam\nHead of PE Department"
    },
    tips: [
      "gives information about something that is going to take place/that needs to be done/that people need to be aware of",
      "standard letter/email format",
      "factual",
      "tone depends on audience"
    ],
    expressions: [
      "I would like to let you know ...",
      "I would like to inform you of ...",
      "I am pleased to inform you that ..."
    ],
    structure: {
      greeting: "greeting/salutation",
      heading: "says what the letter/email is about",
      opening: "reason for writing",
      mainBody: "details presented in cohesive, coherent paragraphs",
      conclusion: "friendly final message + closing remark + contact details",
      closing: "if letter/email is being written to a large body of known people (e.g. parents, students, etc.), 'Yours sincerely' is more friendly"
    }
  },
  
  // Image 2: Letters/emails of invitation
  {
    id: 'invitation-prize-giving',
    type: 'invitation',
    title: 'Prize-Giving Ceremony Invitation',
    category: 'Letters/emails of invitation',
    content: {
      recipient: 'Mr Chung',
      sender: 'Philip Au, Fashion Design Department',
      date: '12 September 20__',
      subject: 'Creative Fashion Design Competition - Prize-Giving Ceremony',
      greeting: 'Dear Mr Chung',
      opening: 'I would like to invite you to be our guest of honour at a prize-giving ceremony for our Creative Fashion Design Competition. This will be held in the Hong Kong Hotel on 16 October 20__ from 6.00 pm to 9.15 pm.',
      mainBody: "Your designs are world-famous and have inspired many designers. It would therefore be a great honour if you could attend our ceremony and present the prizes to our student winners.\n\nThe event will begin at 6.00 pm with light refreshments and dinner will be served from 6.45 pm to 7.45 pm. This will then be followed by a brief speech from our school principal. Prize-giving will begin at 8.00 pm and will be followed by a group photograph of all the winners.\n\nI hope you are able to attend our ceremony and we look forward to receiving your favourable reply. If you have any questions about this event, please feel free to contact me directly on 2356 7789 or at fashionstudents@hkss.edu.hk.",
      conclusion: 'Thank you for your consideration, and I look forward to hearing from you in due course.',
      closing: 'Yours sincerely\nPhilip Au\nFashion Design Department'
    },
    tips: [
      "invites someone to do/attend something",
      "standard letter/email format",
      "persuasive",
      "tone depends on audience"
    ],
    expressions: [
      "Please would you ...?",
      "You are cordially invited to ...",
      "We would appreciate it if you ...",
      "We would like to invite you to ...",
      "It is my pleasure to invite you to ...",
      "Thank you for your consideration."
    ],
    structure: {
      greeting: "greeting/salutation",
      opening: "reason for writing + key information, elaboration/details given in paragraphs that follow",
      mainBody: "elaboration of information given in opening, what the writer would like the reader to do, i.e. respond to the invitation positively",
      conclusion: "friendly final message + closing remark",
      closing: "note: complimentary close should match salutation"
    }
  },

  // Image 3: Letters/emails of application
  {
    id: 'application-trainee-reporter',
    type: 'application',
    title: 'Trainee Reporter Application',
    category: 'Letters/emails of application',
    content: {
      recipient: 'Sir or Madam',
      sender: 'Chris Wong',
      date: '25 June 20__',
      subject: 'Application for Trainee Reporter Position',
      greeting: 'Dear Sir or Madam',
      opening: 'In response to your advertisement in the Hong Kong Evening News on 23 June 20__, I would like to be considered for your trainee reporter position within your new Sports Stars programme. I have attached my CV for your information.',
      mainBody: "I am a Senior Secondary 3 student at Hong Kong Secondary School. I play several sports, with my main sport being table tennis. I have participated in and won medals at several local tournaments and competitions. As a result, I am very familiar with the local sporting scene.\n\nI have been a sports reporter for my school newspaper for the last two years. My duties included regularly submitting articles about events students were involved in.\n\nWith my sporting background and experience, I believe that I have the interest, dedication and necessary experience for your trainee reporter vacancy.",
      conclusion: 'I would welcome the opportunity to discuss my details further with you in an interview.\n\nThank you for your consideration, and I look forward to hearing from you in due course.',
      closing: 'Yours faithfully\nChris Wong'
    },
    tips: [
      "applying for a job, to join something, to be included in something, etc.",
      "standard letter/email format",
      "persuasive, factual, positive",
      "usually formal"
    ],
    expressions: [
      "I feel that I am ...",
      "I believe that I ...",
      "With reference/regards to ...",
      "I would like to be considered ...",
      "I would welcome the opportunity to ...",
      "I am writing to apply for the position of ...",
      "I am writing in response to your advertisement in ... on/dated ..."
    ],
    structure: {
      greeting: "greeting/salutation",
      opening: "reason for writing",
      mainBody: "facts, brief summary of relevant experience/qualifications, etc.",
      conclusion: "what the writer would like the reader to do, i.e. invite him/her for interview, polite final message + closing remark",
      closing: "note: complimentary close should match salutation"
    }
  },

  // Image 4: Responding to letters/emails of complaint
  {
    id: 'complaint-response-bookshop',
    type: 'complaint-response',
    title: 'Bookshop Service Complaint Response',
    category: 'Responding to letters/emails of complaint',
    content: {
      recipient: 'Mr Chan',
      sender: 'D H Wong, Head of Customer Service',
      date: '15 September 20__',
      subject: 'Response to your complaint',
      greeting: 'Dear Mr Chan',
      opening: 'Thank you for your letter of 12 September 20__. I was very sorry to hear about your unpleasant experience in our shop when you were trying to buy a book.',
      mainBody: "When our display books are in poor condition, we of course would try to offer a new copy of these books to our customers. However, if a new copy is unavailable, we would offer a display copy at a discounted price. I believe the member of staff who served you is new, and was at that time unaware of these policies.\n\nWe try and ensure that our service is always the best we can offer. I therefore agree that staff rolling their eyes at you and making you feel uncomfortable is quite unacceptable.\n\nPlease do accept my sincerest apologies for the poor service you experienced. I would like to assure you that the staff member in question has been brought up-to-date on our service expectations. In addition, he has been thoroughly briefed on the standards of service our customers expect to receive.\n\nAs a gesture of goodwill, I have enclosed a HK$100 book voucher for our bookshop. You are very welcome to use this book voucher in any of our shops in Hong Kong.\n\nI would like to again apologise for the service you experienced, Mr Chan, and assure you that this will not happen again.",
      conclusion: 'If you have any further questions, please feel free to contact me directly on 2234 6871.',
      closing: 'Yours sincerely\nD H Wong\nHead of Customer Service'
    },
    tips: [
      "in response to a complaint",
      "standard letter/email format",
      "polite, apologetic, should empathize",
      "usually formal"
    ],
    expressions: [
      "I am sorry that ...",
      "Please be assured that ...",
      "I am/was sorry to hear that ...",
      "I would like to assure you that ...",
      "As a gesture of goodwill, .../As a goodwill gesture, ...",
      "Thank you for your letter/email ...",
      "[Note: never 'thank you for your complaint']"
    ],
    structure: {
      greeting: "greeting/salutation",
      opening: "formal language, reason for writing",
      mainBody: "explanation(s) + apology (if appropriate), new paragraph to answer each complaint item",
      conclusion: "what the writer would like the reader to do, i.e. accept the apology, closing remark + contact information",
      closing: "note: complimentary close should match salutation"
    }
  },

  // Additional samples from original specification
  {
    id: 'informal-weekend-trip',
    type: 'informal',
    title: 'Weekend Trip Email',
    category: 'Informal letters/emails',
    content: {
      recipient: 'julie@greatmail.com',
      sender: 'carmen@greatmail.com',
      date: '28 January 20__',
      subject: 'My weekend',
      greeting: 'Hi Julie',
      opening: "How are you doing? I've just finished my exams, thank goodness! What about you? I think your school has one more week to go, right?",
      mainBody: "Guess what I did on Sunday? I went to Hoi Ha Wan Marine Park with my family!\n\nHave you ever been there? It's a great place and is just north of the Sai Kung Peninsula. Even though it was cold, it was a gorgeous day – blue skies and sunshine. We had a tour guide showing us around, and she was a lot of fun. She talked about conservation, marine life, plants, etc. I took lots of pictures, which I'll put online later this week.\n\nWe should go there when your exams are done. I'd definitely go again as it was so much fun and really interesting.",
      conclusion: "Anyway – don't let me keep you away from your revision! See you soon.",
      closing: 'Regards\nCarmen'
    },
    tips: [
      "personal communication between friends/family",
      "relaxed, conversational tone",
      "can use contractions and informal expressions",
      "less structured than formal letters"
    ],
    expressions: [
      "Guess what!",
      "Got to dash!",
      "Give me a call.",
      "Talk to you later.",
      "Long time no see!",
      "Drop me a line soon.",
      "Let me know what you think.",
      "Send my regards to your family.",
      "What have you been up to lately?",
      "How are you?/How are you doing?",
      "See you soon.",
      "Looking forward to hearing from you soon"
    ]
  },

  {
    id: 'request-lab-visit',
    type: 'request',
    title: 'Science Club Laboratory Visit Request',
    category: 'Letters/emails of request',
    content: {
      recipient: 'Mr Hung',
      sender: 'Gillian Wong, Head of Science',
      date: '12 September 20__',
      subject: 'Laboratory Visit Request',
      greeting: 'Dear Mr Hung',
      opening: 'On behalf of our school Science Club, I would like to ask if it would be possible for the club members to visit your laboratory.',
      mainBody: "We are at present working on a project related to forensic science, and we are focusing on finger-printing. Your laboratory is one of the leading facilities in Hong Kong that works on finger-printing. It would be of enormous benefit to our students to see the kind of work you do, and as a result, learn more about its importance in criminal investigations.\n\nWe can arrange to come at any time that is convenient to you during October. In addition, we are happy to pay for any products you might need to use to demonstrate to the students how finger-printing works.",
      conclusion: 'I very much hope you will consider our request favourably. Please feel free to contact me on 2356 7789 or at scienceclub@hkss.edu.hk.\n\nThank you for your consideration. I look forward to hearing from you in due course.',
      closing: 'Yours sincerely\nGillian Wong\nHead of Science'
    },
    tips: [
      "asking for permission, assistance, or information",
      "polite and respectful tone",
      "clear explanation of what is being requested",
      "offer alternatives or flexibility"
    ],
    expressions: [
      "Please would you...?",
      "I/We would be grateful if you would...",
      "I/We would appreciate it if you could...",
      "I/We look forward to hearing from you.",
      "I/We look forward to your reply/response.",
      "I/We would like to request permission to...",
      "I am writing on behalf of... and would like to...",
      "I/We look forward to hearing from you in due course.",
      "I/We would like to enquire/receive/request/find out about..."
    ]
  },

  {
    id: 'advice-friendship',
    type: 'advice',
    title: 'Friendship Advice Email',
    category: 'Letters/emails of advice',
    content: {
      recipient: 'Robert',
      sender: 'Annie',
      date: '12 September 20__',
      subject: 'About Harry',
      greeting: 'Hi Robert',
      opening: "How're you doing? I was really sorry to hear that you've fallen out with Harry. You two have been friends for years!",
      mainBody: "You said that Harry was angry because you got into the basketball team and he didn't. This must be quite difficult for you, as Harry is probably feeling quite bitter at the moment.\n\nI'd like to give you some suggestions that may help. I think you need to take the initiative here. I think it would be easier for Harry if you emailed him because then he can think about what you say. I suggest you tell him that you were surprised he didn't make the team, but you still think he is a good player. Then ask him to hang out with you at break time, for example. If he does, this would be a good way of trying to go back to being such good friends.\n\nI wouldn't ask Harry to come to basketball practice, as that would make him feel bad. I would guess the last thing he wants to do at the moment is to watch the team he feels has rejected him.",
      conclusion: "Keep trying and don't give up, even if Harry says no to hanging out with you. Respond by asking him to go to the cinema with you, or to the library.\n\nI hope things improve and work out. Let me know how you get on.",
      closing: 'Best wishes\nAnnie'
    },
    tips: [
      "offering suggestions or guidance",
      "empathetic and supportive tone",
      "provide specific, actionable advice",
      "acknowledge the difficulty of the situation"
    ],
    expressions: [
      "Drop me a line.",
      "I've noticed that you're...",
      "As for the problem with...",
      "Try not to worry too much.",
      "Can I give you some advice?",
      "You seem to be worried by...",
      "Let me know how you get on.",
      "I was sorry to hear that/about...",
      "Give me a call to let me know how things are.",
      "I'd like to give you some suggestions that might help.",
      "Remember – I'm here to help. That's what friends are for!"
    ]
  },

  {
    id: 'complaint-bookshop-service',
    type: 'complaint',
    title: 'Bookshop Service Complaint',
    category: 'Letters/emails of complaint',
    content: {
      recipient: 'To whom it may concern',
      sender: 'Tom Chan',
      date: '12 September 20__',
      subject: 'Complaint about service',
      greeting: 'To whom it may concern',
      opening: 'I am writing to complain about the appalling service I experienced in your Causeway Bay bookshop on Saturday 11 September 20__.',
      mainBody: "I was looking through your selection of books for learning Spanish. I found the book I wanted, but it was quite tatty as it had been looked at by many customers. I approached one of your members of staff and asked if I could buy it, but that I would like to have a new copy. Your member of staff simply rolled his eyes and said no. I thought this was very rude. However, I politely explained that the book was damaged and if there were no new copies in stock, then I was happy to buy the display copy, but at a discounted price. I was scowled at and, after a minute or so of huffing and puffing, told that there was no discount available. Moreover, if I wanted to buy the book I had to order it, and it would take six weeks to arrive!\n\nI was horrified that your staff would be so rude and unhelpful to their customers. I was very keen to buy this book, but I came away with the distinct impression that I was not welcome in your shop.\n\nI think under the circumstances, it is reasonable for me to ask for a letter of apology from the staff member concerned at your Causeway Bay shop. I am not going to buy the book from your shop. In fact, I have been to one of your competitors. Their shop staff were very friendly and helpful, and they could sell me an undamaged copy of the book I wanted.",
      conclusion: 'I look forward to receiving a letter of apology from you in due course.',
      closing: 'Yours faithfully\nTom Chan'
    },
    tips: [
      "expressing dissatisfaction about a product or service",
      "formal tone with controlled emotion",
      "provide specific details and facts",
      "state what resolution is expected"
    ],
    expressions: [
      "Can you kindly explain...?",
      "I am afraid I must insist...",
      "I am writing to complain about...",
      "I look forward to receiving a refund.",
      "Under the circumstances, I would expect...",
      "I am writing to express my shock/disappointment...",
      "As I am sure you will agree, it would seem reasonable to expect..."
    ]
  },

  // Image 9: Letters/emails to the editor
  {
    id: 'editor-response-teens',
    type: 'editor',
    title: 'Response to "Irresponsible Teens"',
    category: 'Letters/emails to the editor',
    content: {
      recipient: 'Editor',
      sender: 'Florence Ip Chai Wan',
      date: '12 September 20__',
      subject: 'Response to "Irresponsible Teens"',
      greeting: 'Dear Editor',
      opening: 'I am writing in response to the letter entitled "Irresponsible Teens" by Ms Ivy Hui, dated 8 September. I strongly disagree with Ms Hui\'s opinion of teens in Hong Kong.',
      mainBody: "In Ms Hui's letter, she concluded that Hong Kong teenagers have low standards of behaviour and poor manners.\n\nI agree that the teenagers Ms Hui was referring to do indeed have low standards of behaviour – but this is not the norm among teens. In my opinion, any form of vandalism or graffiti shows a total lack of respect for a community. But I would suggest that the teenagers referred to by Ms Hui are in the minority.\n\nThe majority of teenagers in Hong Kong involve themselves in community-based activities for the betterment of Hong Kong and its citizens. You will see these young people fund raising, selling flags, helping the elderly, helping at charity events and doing voluntary work. It is sad that a minority of badly-behaved individuals have resulted in Ms Hui concluding that all teens are the same. We are not.\n\nWe need to look at the good that is being done by teens in Hong Kong, and punish those who simply spoil things for others. Moreover, the general public needs to remember that the acts of one or two individuals are not representative of an entire section of our community.",
      conclusion: "No two people are the same. Let's remember to judge each person on their own merit rather than by what others do.",
      closing: "Florence Ip\nChai Wan"
    },
    tips: [
      "in response to a letter or an article in a newspaper, or something that is being discussed within a community",
      "similar format to that of a letter or an email",
      "persuasive, direct, strong opinions expressed",
      "formal"
    ],
    expressions: [
      "Let's all ...",
      "To conclude, ...",
      "Isn't it possible that ...",
      "I strongly suggest that ...",
      "We should all consider ...",
      "I would like to respond to ...",
      "I absolutely agree/disagree with",
      "... contradicts him/herself in saying that ..."
    ],
    structure: {
      date: "12 September 20__",
      greeting: "Dear Editor (can also use 'Dear Sir or Madam')",
      opening: "clear reference to letter/article/community topic + clear statement of opinion",
      mainBody: "reasons for writer's opinion - elaboration + examples",
      conclusion: "final persuasive statement that is a 'call for action'",
      closing: "name and district only"
    }
  },

  // Image 10: Letters/emails of enquiry
  {
    id: 'enquiry-table-tennis',
    type: 'enquiry',
    title: 'Table Tennis Products Enquiry',
    category: 'Letters/emails of enquiry',
    content: {
      recipient: 'Ms Lee',
      sender: 'Ian Chan, PE Department',
      date: '3 March 20__',
      subject: 'Table tennis products',
      greeting: 'Dear Ms Lee',
      opening: 'I would like to enquire about the table tennis products advertised in your brochure. As our school table tennis tables and paddles are now quite old, we are considering buying new table tennis equipment.',
      mainBody: "We are at present considering buying two new tables and twenty new table tennis paddles. We may need more table tennis balls, and perhaps two new nets for our existing tables.\n\nI would appreciate it if you could send me further information about your prices for table tennis equipment, as well as details of any discounts that you offer to schools.",
      conclusion: "Please would you email the price details to tabletennisfans@hkss.edu.hk? I look forward to receiving this information.",
      closing: "Yours sincerely\nIan Chan\nPE Department"
    },
    tips: [
      "asks for information about a product, a service, etc.",
      "standard letter/email format",
      "tone depends on purpose and audience"
    ],
    expressions: [
      "Please would you ...?",
      "I/We would be grateful if you would ...",
      "I/We would appreciate it if you could ...",
      "I/We would like to enquire/receive/find out about ...",
      "I/We look forward to hearing from you in due course."
    ],
    structure: {
      date: "3 March 20__",
      greeting: "Dear Ms Lee",
      heading: "says what the letter/email is about",
      opening: "reason for writing",
      mainBody: "details presented in cohesive, coherent paragraphs",
      conclusion: "contact details + closing remark",
      closing: "note: complimentary close should match salutation"
    }
  },

  // Image 11: Letters/emails of promotion
  {
    id: 'promotion-christmas-programme',
    type: 'promotion',
    title: 'Christmas Programme Promotion',
    category: 'Letters/emails of promotion',
    content: {
      recipient: 'students',
      sender: 'Sung A M, Head of Chinese Department',
      date: '1 December 20__',
      subject: 'Christmas Programme',
      greeting: 'Dear students',
      opening: 'The Christmas break is fast approaching, and you may be wondering what to do over the holiday period. Well, we\'ve got a suggestion we\'d like to share with you!',
      mainBody: "Why not enrol in the Putonghua Society's Christmas programme? Not only can you improve your language skills, you can also enjoy taking part in our Putonghua Christmas activities. You'll be able to have fun with your friends while revising and improving your Putonghua language skills at the same time!\n\nThe fees for this programme are nominal. All you need to pay is HK$250! This will be used to cover the cost of your course materials.\n\nThere are 20 places available for this programme and they're open to Senior Secondary 2 students only.\n\nIf you'd like to take part in this fun Christmas programme, you'll need to sign up quickly! Simply write your name and class on the sign-up list on the Putonghua notice board outside of the staff room.",
      conclusion: "Don't miss out on this fabulous, fun and educational opportunity!",
      closing: "Yours sincerely\nSung A M\nHead of Chinese Department"
    },
    tips: [
      "promotes/advertises a product/service",
      "standard letter/email format",
      "persuasive",
      "often semi-formal"
    ],
    expressions: [
      "Are you ...?",
      "Don't delay!",
      "It only costs ...",
      "Don't miss out!",
      "Have you considered ...?",
      "It just takes a moment to ...",
      "You can enjoy a discount of ...",
      "I am delighted to let you know that ..."
    ],
    structure: {
      date: "1 December 20__",
      greeting: "address recipient directly OR a group of people, e.g. students",
      opening: "reason for writing",
      mainBody: "what the writer would like the reader to do when s/he finishes reading the letter/email, i.e. sign up for the programme",
      conclusion: "final persuasive message",
      closing: "note: if written to a group that you know, e.g. students or parents, 'Yours sincerely' is more friendly"
    }
  },

  // Image 13: Notices
  {
    id: 'notice-chess-competition',
    type: 'notice',
    title: 'Chinese Chess Competition Schedule',
    category: 'Notices',
    content: {
      recipient: 'members of the Chinese Chess Club',
      sender: 'chesssuper@hkoo.edu.hk',
      date: '3 March 20__',
      subject: 'New schedule for annual Chinese Chess Competition',
      greeting: 'Dear members of the Chinese Chess Club',
      opening: 'Because of the hoisting of tropical cyclone signal No. 8 on 2 March, our scheduled competition for that day was cancelled. We have therefore rescheduled this competition.',
      mainBody: "The rescheduled Chinese Chess Competition will take place on Saturday 10 March, from 9.30 am to 11.45 am. Please come to the school hall and sign in by 9.15 am on Saturday 10 March. You will be told who you are going to play against and where you should sit. The boards will all have been set up for you.\n\nThe competition will end at 11.30 am. You will then be able to enjoy some light refreshments and talk with other players in the club.\n\nPlease let us know by 6 March if you want to compete in the competition so that we can finalise arrangements. You can email your application to chesssuper@hkoo.edu.hk.",
      conclusion: "Should you have any questions about the competition, please email chesssuper@hkoo.edu.hk or call us at 2345 6789.",
      closing: ""
    },
    tips: [
      "usually displayed in public places, e.g. on school bulletin boards, in lift lobbies, etc.",
      "gives information about, e.g. activities, new services, warnings, etc.",
      "similar format to that of a letter or an email",
      "tone depends on purpose and audience, e.g. a school notice could be semi-formal, a public notice is likely to be formal"
    ],
    expressions: [
      "Please note that ...",
      "We would like to ...",
      "If you would like to ..., ...",
      "The venue of ... has changed from ... to ...",
      "I am pleased to inform you/tell you that ...",
      "We apologize for any inconvenience caused.",
      "If/Should you have any questions/queries/enquiries, please contact ..."
    ],
    structure: {
      date: "3 March 20__",
      heading: "says what the notice is about",
      greeting: "can include a greeting (not all notices do so)",
      introduction: "reason for writing",
      mainBody: "details presented in cohesive, coherent paragraphs",
      conclusion: "what the writer would like the reader to do, i.e. email the club if want to compete in the competition",
      closing: "closing remark + contact details; note: some notices include the writer's name/organization, some do not"
    }
  },

  // Image 14: Proposals
  {
    id: 'proposal-dvd-collection',
    type: 'proposal',
    title: 'DVD Collection Extension Proposal',
    category: 'Proposals',
    content: {
      recipient: 'Ms Ho, Librarian',
      sender: 'Film Club',
      date: '',
      subject: 'To suggest ways in which the DVD collection in the school library can be extended',
      greeting: '',
      opening: 'The DVD collection in the school library is very popular. Many students enjoy borrowing the films and watching them at home over the weekend. However, due to their popularity, most of the films are usually gone by Thursday, so many students miss out on the benefits of watching films in English.',
      mainBody: "The purpose of this proposal is to suggest ways in which the DVD collection in the school library can be extended at no additional cost to the library.\n\n**Student donations**\nMany students have DVDs that they no longer watch or want. They could donate these to the school library. The Film Club would be happy to draft an email to all students informing them of this. Film Club members could then help collect, sort and catalogue any donated DVDs.\n\n**Teacher donations**\nTeachers are also likely to have DVDs they no longer want. Again, the Film Club could email teachers and also help collect and sort any DVDs they donate.\n\n**Donation boxes**\nA special box could be placed inside the door of the library. Students and teachers could deposit their unwanted DVDs in this box. Film Club members could help organise this.",
      conclusion: "To conclude, it would be possible to extend the school library's DVD collection at no additional cost by asking teachers and students to donate their unwanted DVDs. The Film Club could be responsible for letting students and teachers know about how they can donate unwanted DVDs, and for collecting and cataloguing donated DVDs.",
      closing: ""
    },
    tips: [
      "makes/presents suggestions about, e.g. a new service, club, product, etc.",
      "persuasive",
      "based on facts",
      "standard format",
      "usually formal"
    ],
    expressions: [
      "This proposal suggests ...",
      "To conclude, .../In conclusion, ...",
      "I/we would recommend/It is recommended that ...",
      "There has been a problem with ..., therefore it is proposed/I would like to propose ..."
    ],
    structure: {
      recipient: "Ms Ho, Librarian",
      sender: "Film Club",
      proposal: "To suggest ways in which the DVD collection in the school library can be extended",
      introduction: "common proposal format with headings for each section; background information",
      mainBody: "clearly stated purpose of the proposal; suggestions and details; usually organised under headings",
      conclusion: "note: not all proposals have recommendations, but those should always have a conclusion. Recommendations suggest what should be done, based on the conclusion"
    }
  }
];

export const categories = [
  'all',
  'Informal letters/emails',
  'Letters/emails of request',
  'Letters/emails of advice',
  'Letters/emails of complaint',
  'Responding to letters/emails of complaint',
  'Letters/emails to inform',
  'Letters/emails of invitation',
  'Letters/emails of application',
  'Letters/emails to the editor',
  'Letters/emails of enquiry',
  'Letters/emails of promotion',
  'Memos',
  'Notices',
  'Proposals',
  'Newspaper/magazine articles',
  'Press releases',
  'Reports',
  'Leaflets/pamphlets',
  'Profiles',
  'Speeches'
];

export const templateTypes = [
  { value: 'informal', label: 'Informal letters/emails' },
  { value: 'request', label: 'Letters/emails of request' },
  { value: 'advice', label: 'Letters/emails of advice' },
  { value: 'complaint', label: 'Letters/emails of complaint' },
  { value: 'complaint-response', label: 'Responding to complaints' },
  { value: 'inform', label: 'Letters/emails to inform' },
  { value: 'invitation', label: 'Letters/emails of invitation' },
  { value: 'application', label: 'Letters/emails of application' }
];

export const usefulExpressions = {
  informal: [
    "Guess what!", "Got to dash!", "Give me a call.", "Talk to you later.",
    "Long time no see!", "Drop me a line soon.", "Let me know what you think.",
    "Send my regards to your family.", "What have you been up to lately?",
    "How are you?/How are you doing?", "See you soon.", "Looking forward to hearing from you soon"
  ],
  request: [
    "Please would you...?", "I/We would be grateful if you would...",
    "I/We would appreciate it if you could...", "I/We look forward to hearing from you.",
    "I/We look forward to your reply/response.", "I/We would like to request permission to...",
    "I am writing on behalf of... and would like to...", "I/We look forward to hearing from you in due course.",
    "I/We would like to enquire/receive/request/find out about..."
  ],
  advice: [
    "Drop me a line.", "I've noticed that you're...", "As for the problem with...",
    "Try not to worry too much.", "Can I give you some advice?", "You seem to be worried by...",
    "Let me know how you get on.", "I was sorry to hear that/about...",
    "Give me a call to let me know how things are.", "I'd like to give you some suggestions that might help.",
    "Remember – I'm here to help. That's what friends are for!"
  ],
  complaint: [
    "Can you kindly explain...?", "I am afraid I must insist...",
    "I am writing to complain about...", "I look forward to receiving a refund.",
    "Under the circumstances, I would expect...", "I am writing to express my shock/disappointment...",
    "As I am sure you will agree, it would seem reasonable to expect..."
  ],
  'complaint-response': [
    "I am sorry that ...", "Please be assured that ...", "I am/was sorry to hear that ...",
    "I would like to assure you that ...", "As a gesture of goodwill, .../As a goodwill gesture, ...",
    "Thank you for your letter/email ...", "[Note: never 'thank you for your complaint']"
  ],
  inform: [
    "I would like to let you know ...", "I would like to inform you of ...",
    "I am pleased to inform you that ..."
  ],
  invitation: [
    "Please would you ...?", "You are cordially invited to ...", "We would appreciate it if you ...",
    "We would like to invite you to ...", "It is my pleasure to invite you to ...",
    "Thank you for your consideration."
  ],
  application: [
    "I feel that I am ...", "I believe that I ...", "With reference/regards to ...",
    "I would like to be considered ...", "I would welcome the opportunity to ...",
    "I am writing to apply for the position of ...", "I am writing in response to your advertisement in ... on/dated ..."
  ]
};
